import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { InjectionToken, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FgaModule } from './fga/fga.module';
import { CommonModule } from '@angular/common'

import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';

import { AgGridModule } from 'ag-grid-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Constants } from './constants';
import { DialogComponent } from './core/dialog/dialog.component';
import { FooterComponent } from './core/footer/footer.component';
import { GridbuttonComponent } from './core/gridbutton/gridbutton.component';
import { SupplierCellRendererComponent } from './core/supplier-cell-renderer/supplier-cell-renderer.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from './core/header/header.component';
import { ToolbarComponent } from './core/toolbar/toolbar.component';
import { ActualComponent } from './page/actual/actual.component';
import { FinalPackageComponent } from './page/final-package/final-package.component';
import { PlanComponent } from './page/plan/plan.component';
import { SupplementsComponent } from './page/supplements/supplements.component';
import { BreadcrumbComponent } from './core/breadcrumb/breadcrumb.component';

//Msal
import { MsalService, MSAL_INSTANCE, MsalGuard, MsalInterceptor, MsalBroadcastService } from './msal';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { environment } from 'src/environments/environment';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/cache';
import { AddParamsInterceptor } from './add-params.interceptor';
import {
    MsalInterceptorConfiguration,
    MsalGuardConfiguration,
  } from '@azure/msal-angular';
  import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
   
  ModuleRegistry.registerModules([ AllCommunityModule ]);
  
export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.CLIENT_ID,
			authority: environment.TENANT_ID,
			redirectUri: environment.REDIRECT_URL
		}
	});
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(
      environment.REDIRECT_URL,
      environment.SCOPES
    );
  
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
    };
  }
  export const FGA_API_ENDPOINT = new InjectionToken<string>('FGA_API_ENDPOINT');

  export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [...environment.SCOPES],
      },
      loginFailedRoute: '/unauthorized',
    };
  }
export function initializeMsal(instance: IPublicClientApplication): () => Promise<void> {
    return () => instance.initialize();
}
import { TldreturnsService } from './service/tldreturns.service';

const cntr = 'center-center'

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 60,
  bgsType: 'ball-spin-clockwise',
  blur: 5,
  delay: 0,
  fastFadeOut: true,
  fgsColor: 'red',
  fgsPosition: cntr,
  fgsSize: 60,
  fgsType: 'ball-spin-clockwise',
  gap: 24,
  logoPosition: cntr,
  logoSize: 120,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: 'rgba(40, 40, 40, 0.8)',
  pbColor: 'red',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: cntr,
  maxTime: -1,
  minTime: 300,
};

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    ToolbarComponent,
    ActualComponent,
    PlanComponent,
    SupplementsComponent,
    FinalPackageComponent,
    GridbuttonComponent,
    DialogComponent,
    SupplierCellRendererComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatMenuModule,
    MatListModule,
    FormsModule,
    AgGridModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCardModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatTooltipModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    BrowserAnimationsModule,
    MatTabsModule,
    FgaModule,
    CommonModule,
    BreadcrumbComponent,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
  ],

  providers: [
    Constants,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AddParamsInterceptor,
        multi: true
      },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
  },
  {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
  },
  provideAppInitializer(() => {
      const msalInstance = inject(MSAL_INSTANCE);
      return msalInstance.initialize();
    }),
    { provide: FGA_API_ENDPOINT, useValue: environment.APM_DS_URI },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
        return { cache: new InMemoryCache() };
      }),
    TldreturnsService,
  ],
  
})
export class AppModule {}

